<template>
  <LoadingSpinner v-if="listaParametros.length == 0" />
  <div class="py-4 container" v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="text-end"></div>
          <div class="table-responsive">
            <table
              class="table table-bordered table-striped table-sm text-center text-sm table-sm"
            >
              <thead>
                <tr class="bg-gradient-light text-dark">
                  <th colspan="3"></th>
                  <th colspan="5">Comisiones</th>
                  <th></th>
                </tr>
                <tr>
                  <th>Arrendamiento</th>
                  <th>Fondeo</th>
                  <th>TIIE</th>
                  <th>Ejecutivo</th>
                  <th>Líder</th>
                  <th>Agencia</th>
                  <th>Broker</th>
                  <th>Marketing</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="{
                    id,
                    arrendamiento,
                    fondeo,
                    tiie,
                    comision_ejecutivo,
                    comision_lider,
                    comision_agencia,
                    comision_externo,
                    comision_marketing,
                  } in listaParametros"
                  :key="id"
                >
                  <td class="align-middle">{{ arrendamiento }}</td>
                  <td class="align-middle">{{ fondeo }}%</td>
                  <td class="align-middle">{{ tiie }}%</td>
                  <td class="align-middle">{{ comision_ejecutivo }}%</td>
                  <td class="align-middle">{{ comision_lider }}%</td>
                  <td class="align-middle">{{ comision_agencia }}%</td>
                  <td class="align-middle">{{ comision_externo }}%</td>
                  <td class="align-middle">{{ comision_marketing }}%</td>
                  <td
                    class="align-middle align-items-center d-flex flex-column"
                  >
                    <router-link
                      :to="{
                        name: 'cotizacion-unidades-parametros-editar',
                        params: {
                          parametro_id: id,
                        },
                      }"
                    >
                      <button class="btn btn-primary btn-sm">Modificar</button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useCotizacionParametros } from "@/composables/useCotizacionParametros";
import LoadingSpinner from "@/components/LoadingComponent.vue";

const { listaParametros, get, parametros } = useCotizacionParametros();

onMounted(() => {
  get();
});
</script>
